import { useState } from "react"

export const usePinterestVisibilityProps = () => {
  const [isHoveringImage, setIsHoveringImage] = useState(false)

  return {
    imageProps: {
      onMouseEnter: () => setIsHoveringImage(true),
      onMouseLeave: () => setIsHoveringImage(false),
    },
    pinterestButtonProps: {
      isVisible: isHoveringImage,
      onMouseEnter: () => setIsHoveringImage(true),
    },
  }
}
